<div class="ng-modal-backdrop" *ngIf="visible">
  <div class="ng-modal-card">
    <div class="nodegroup-modal-header">
      <div class="eks-request-modal-title">
        <div class="eks-request-modal-icon">
          <i class="fa fa-cubes"></i>
        </div>
        <div>
          <h5>Add Node Group</h5>
          <div class="eks-request-modal-subtitle">
            Request a managed node group by selecting compute, scaling, storage, and tags.
          </div>
        </div>
      </div>
      <button type="button" class="eks-request-modal-close" aria-label="Close popup" (click)="requestClose()"> <i class="fa fa-times"></i></button>
    </div>
    <div class="eks-request-steps">
      <div class="eks-request-step" [class.active]="!showPricingStep" [class.done]="showPricingStep">
        <span class="eks-request-step__badge">
          <i *ngIf="showPricingStep" class="fa fa-check"></i>
          <ng-container *ngIf="!showPricingStep">1</ng-container>
        </span>
        <span class="eks-request-step__label">Node Group Details</span>
      </div>
      <div class="eks-request-step" [class.active]="showPricingStep">
        <span class="eks-request-step__badge">2</span>
        <span class="eks-request-step__label">Review Pricing</span>
      </div>
    </div>
    <div class="nodegroup-modal-body">
      <div *ngIf="!showPricingStep">
      <h5>Node group details</h5>
      <p class="eks-request-copy">Provide node group settings and verify defaults inherited from the cluster request.</p>
      <div class="eks-request-context">
        <div class="eks-request-context-chip">
          <span>Cluster</span>
          <strong>{{ nodeGroupContext?.cluster_name || "-" }}</strong>
        </div>
      </div>
      <div class="mb-3">
        <label>Launch Justification <span class="required-star">*</span></label>
        <textarea class="form-control" [(ngModel)]="nodeGroupForm.launch_justification" rows="2" placeholder="Enter launch justification"></textarea>
      </div>
      <div class="mb-3">
        <label>Node Group Name <span class="required-star">*</span></label>
        <input class="form-control" [(ngModel)]="nodeGroupForm.nodegroup_name" placeholder="Enter node group name" />
      </div>
      <div class="mb-3">
        <label>Node Role ARN <span class="required-star">*</span> <span *ngIf="nodeGroupLoading.nodeRoles" class="tiny-loader"></span></label>
        <ng-select class="instance-type-select" [items]="nodeGroupOptions.nodeRoles" bindLabel="role_arn" bindValue="role_arn" [(ngModel)]="nodeGroupForm.node_role_arn" [searchable]="true" [clearable]="true" placeholder="Select"></ng-select>
      </div>
      <div class="mb-3">
        <label>Subnet IDs <span *ngIf="nodeGroupLoading.requestDetails" class="tiny-loader"></span></label>
        <div class="small text-muted mt-1" *ngIf="nodeGroupForm.subnet_ids?.length">{{ nodeGroupForm.subnet_ids.join(", ") }}</div>
        <div class="small text-muted mt-1" *ngIf="!nodeGroupLoading.requestDetails && !(nodeGroupForm.subnet_ids?.length)">No subnet ids found from request details API.</div>
      </div>
      <div class="mb-3">
        <label>Instance Types <span class="required-star">*</span></label>
        <ng-select class="instance-type-select instance-metadata-select" [items]="nodeGroupOptions.instanceTypes" bindLabel="instance_type" bindValue="instance_type" [(ngModel)]="nodeGroupForm.instance_types" [multiple]="true" [searchable]="true" [clearable]="true" placeholder="Select">
          <ng-template #instanceTypeDetails let-item>
            <div class="instance-option">
              <div class="instance-option__title">{{ item.instance_type }}</div>
              <div class="instance-option__meta">
                <span>vCPU: {{ item.vcpu ?? "-" }}</span>
                <span>Memory: {{ item.memory || "-" }}</span>
              </div>
            </div>
          </ng-template>
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <ng-container *ngTemplateOutlet="instanceTypeDetails; context: { $implicit: item }"></ng-container>
            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">x</span>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <ng-container *ngTemplateOutlet="instanceTypeDetails; context: { $implicit: item }"></ng-container>
          </ng-template>
        </ng-select>
      </div>
      <div class="mb-3">
        <label>AMI Type <span class="required-star">*</span> <span *ngIf="nodeGroupLoading.amiOptions" class="tiny-loader"></span></label>
        <ng-select class="instance-type-select" [(ngModel)]="nodeGroupForm.ami_type" [searchable]="true" [clearable]="true" placeholder="Select">
          <ng-option *ngFor="let ami of nodeGroupOptions.amiOptions" [value]="ami.ami_type">{{ ami.label || ami.ami_type }}</ng-option>
        </ng-select>
        <div class="small text-muted mt-1" *ngIf="!nodeGroupLoading.amiOptions && amiWarning">{{ amiWarning }}</div>
      </div>
      <div class="mb-3">
        <label>Capacity Type</label>
        <input class="form-control" [value]="'ON_DEMAND'" disabled />
      </div>
      <div class="row g-2 scale-grid">
        <div class="col-4"><label>Min</label><input type="number" class="form-control" [(ngModel)]="nodeGroupForm.scaling_min" /></div>
        <div class="col-4"><label>Max</label><input type="number" class="form-control" [(ngModel)]="nodeGroupForm.scaling_max" /></div>
        <div class="col-4"><label>Desired</label><input type="number" class="form-control" [(ngModel)]="nodeGroupForm.scaling_desired" /></div>
      </div>
      <div class="row g-2 mb-3 mt-1">
        <div class="col-12 col-md-6">
          <label>Disk Size (GiB)</label>
          <input type="number" class="form-control" [(ngModel)]="nodeGroupForm.disk_size" />
        </div>
      </div>
      <div class="mb-2">
        <label>Tags</label>
        <div *ngFor="let t of nodeGroupForm.tags; let i = index" class="tag-row">
          <input class="form-control" placeholder="key" [(ngModel)]="t.key" />
          <input class="form-control" placeholder="value" [(ngModel)]="t.value" />
          <button type="button" class="btn btn-outline-secondary btn-sm tag-remove" (click)="removeNodeGroupTag(i)">X</button>
        </div>
        <button type="button" class="btn btn-light btn-sm mt-2 add-tag-btn" (click)="addNodeGroupTag()"><i class="fa fa-plus"></i> Add Tag</button>
      </div>
      </div>

      <div *ngIf="showPricingStep">
        <h5>Review pricing</h5>
        <p class="eks-request-copy">Review the estimated cost before submitting the node group request.</p>
        <div *ngIf="nodeGroupLoading.pricing" class="mapping-box">Fetching pricing...</div>
        <div *ngIf="!nodeGroupLoading.pricing && pricingError" class="mapping-box text-danger">{{ pricingError }}</div>
        <div *ngIf="!nodeGroupLoading.pricing && nodeGroupPricing" class="mapping-box">
          <div class="mb-2">
            <label>Hourly Cost</label>
            <input class="form-control" [ngModel]="(nodeGroupPricing.total_hourly_usd ?? nodeGroupPricing.per_instance_hourly_usd ?? nodeGroupPricing.hourly_cost_usd ?? nodeGroupPricing.hourly_cost ?? '-') + ' ' + (nodeGroupPricing.currency || 'USD')" disabled />
          </div>
          <div>
            <label>Monthly Cost</label>
            <input class="form-control" [ngModel]="(nodeGroupPricing.total_monthly_usd ?? nodeGroupPricing.per_instance_monthly_usd ?? nodeGroupPricing.monthly_cost_usd ?? nodeGroupPricing.monthly_cost ?? '-') + ' ' + (nodeGroupPricing.currency || 'USD')" disabled />
          </div>
        </div>
      </div>

      <div *ngIf="formError" class="alert alert-warning mb-0 mt-3">{{ formError }}</div>
      <div *ngIf="createSuccessMessage" class="alert alert-success mt-3 mb-0">{{ createSuccessMessage }}</div>
      <div *ngIf="createErrorMessage" class="alert alert-danger mt-3 mb-0">{{ createErrorMessage }}</div>
    </div>
    <div class="nodegroup-modal-footer">
      <button class="btn btn-light me-2" [disabled]="nodeGroupLoading.submit || nodeGroupLoading.pricing" (click)="showPricingStep ? backToForm() : requestClose()">
        <ng-container *ngIf="!showPricingStep">Cancel</ng-container>
        <ng-container *ngIf="showPricingStep"><i class="fa fa-arrow-left"></i> Back</ng-container>
      </button>
      <div class="eks-request-footer-meta">Step {{ showPricingStep ? 2 : 1 }} of 2</div>
      <button *ngIf="!showPricingStep" class="btn btn-primary" [disabled]="nodeGroupLoading.pricing" (click)="goToPricing()">
        {{ nodeGroupLoading.pricing ? "Loading..." : "Next" }} <i *ngIf="!nodeGroupLoading.pricing" class="fa fa-arrow-right"></i>
      </button>
      <button *ngIf="showPricingStep" class="btn btn-primary" [disabled]="nodeGroupLoading.submit || !nodeGroupPricing || !!pricingError || !!createSuccessMessage" (click)="submitNodeGroupRequest()">{{ nodeGroupLoading.submit ? "Submitting..." : "Submit Request" }}</button>
    </div>
  </div>
</div>
